// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import $ from 'jquery'
// 引入vuex
import store from './store/index'
import axios from 'axios'; /* 引入axios进行地址访问*/ 　　
import qs from 'qs'
import JsonExcel from 'vue-json-excel'
import * as echarts from 'echarts'

// 导入全局样式表
import '../static/css/global.css'

import timeChange from './utils/timeChange'
import tiemChangeToM from './utils/tiemChangeToM'
Vue.prototype.$echarts = echarts
axios.defaults.baseURL = 'https://php.zgsj1.com/index.php/gx/mchine.Mchine/';
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
// 时间戳
Vue.prototype.$timeChange = timeChange
Vue.prototype.$tiemChangeToM = tiemChangeToM

// import VueJsonp from 'vue-jsonp'
// Vue.use(VueJsonp) //解决跨域
axios.interceptors.request.use(config => {
    // 表示在配置中的设置头消息的字段Authorization为从本地获取的token值
    if (window.localStorage.getItem('AdminToken')) {
        config.headers.common['AdminToken'] = window.localStorage.getItem('AdminToken')
    } else {

    }
    
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.headers['Content-Type'] = 'application/json'
    config.headers.Accept = 'application/json, text/plain, */*'
    // console.log(config, "456789")
    return config
})

import less from 'less'
Vue.use(less)
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);

import './publicCss/publicStyle.css' //公共样式

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js